import { EVENTS } from '../config'
import { useEffect, useRef, useState } from 'react'
import SETTINGS, { Settings } from '../controllers/settings'

export const useSettings = (): Settings => {
	const settings = SETTINGS
	// An internal state to force rerendering when settings change
	// The actual "settings" object is a singleton, so it doesn't change, and won't trigger rerendering
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [rerender, setRerender] = useState(0)
	const renderNum = useRef(0)

	useEffect(() => {
		const triggerRerender = () => {
			renderNum.current += 1
			setRerender(renderNum.current)
		}
		settings.on(EVENTS.SETTINGS_CHANGED, triggerRerender)
		return () => settings.off(EVENTS.SETTINGS_CHANGED, triggerRerender)
	}, []) // Run this hook only once, on mount

	return settings
}
